import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import {CdkMenu, CdkMenuBar, CdkMenuItem, CdkMenuItemCheckbox, CdkMenuTrigger} from '@angular/cdk/menu';
import { XMenuItemComponent } from '../x-menu-item/x-menu-item.component';
import {XDividerComponent} from "../x-divider/x-divider.component";

export type TMenuItem = {
  id: string;
  text: string;
  disabled?: boolean;
  submenu?: TemplateRef<any>;
  leadingIcon?: string;
  trailingIcon?: string;
};

export type TMenuItemToggle = {
  id: string;
  text: string;
  submenu?: TemplateRef<any>;
  leadingIcon?: string;
  disabled?: boolean;
  isToggle: true;
  toggleValue: boolean;
  trailingIcon?: string;
};
@Component({
  selector: 'app-x-menu',
  standalone: true,
  imports: [
    CdkMenu,
    CdkMenuItem,
    XMenuItemComponent,
    CdkMenuTrigger,
    CdkMenuBar,
    CdkMenuItemCheckbox,
    XDividerComponent,
  ],
  templateUrl: './x-menu.component.html',
  styleUrl: './x-menu.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XMenuComponent {
  @Input() items: (TMenuItem | TMenuItemToggle)[] = [];
  @Input() active: number | string = -1;
  @Input() withSelectedIcons: boolean = true;

  @Input() secondItems: (TMenuItem | TMenuItemToggle)[] = [];
  @Input() activeSecond: number | string = -1;

  @Input() top: number | null = null;
  @Input() left: number | null = null;

  // Применяем фиксированное позиционирование только если top и left явно установлены
  @HostBinding('style.position') get position() { 
    return (this.top !== null && this.left !== null) ? 'fixed' : null; 
  }
  @HostBinding('style.top.px') get topStyle() { 
    return this.top !== null ? this.top : null; 
  }
  @HostBinding('style.left.px') get leftStyle() { 
    return this.left !== null ? this.left : null; 
  }
  @HostBinding('style.z-index') get zIndex() { 
    return (this.top !== null && this.left !== null) ? 1000 : null; 
  }

  @Output() activeChange = new EventEmitter<TMenuItem>();
  @Output() activeSecondChange = new EventEmitter<TMenuItem>();

  public onItemClick(item: TMenuItem) {
    if (item.submenu) {
      return;
    }

    this.activeChange.emit(item);
  }

  public onSecondItemClick(item: TMenuItem) {
    if (item.submenu) {
      return;
    }

    this.activeSecondChange.emit(item);
  }

  public isToggleItem(item: TMenuItem | TMenuItemToggle): item is TMenuItemToggle {
    return (<any>item).isToggle;
  }
}
